import React from 'react'
import { Typography, Button, Tag } from 'antd'
import { RightOutlined, CalendarOutlined, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import '../../../../styling/ResultListItem.css'

const { Text } = Typography

const ResultListItem = ({ result, dataPoint, onViewDetail }) => {
  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    })
  }

  // Determine if result is normal or abnormal
  const getResultStatus = () => {
    if (!result.value || !dataPoint?.data) return 'unknown'

    try {
      const referenceRanges = JSON.parse(dataPoint.data).referenceRangeData || []
      if (referenceRanges.length === 0) return 'unknown'

      const value = parseFloat(result.value)
      let isNormal = false

      for (const range of referenceRanges) {
        const min = range.min !== undefined ? parseFloat(range.min) : null
        const max = range.max !== undefined ? parseFloat(range.max) : null

        if ((min === null || value >= min) && (max === null || value <= max)) {
          isNormal = true
          break
        }
      }

      return isNormal ? 'normal' : 'abnormal'
    } catch (e) {
      return 'unknown'
    }
  }

  const resultStatus = getResultStatus()

  return (
    <div className='result-list-item' onClick={() => onViewDetail(result)}>
      <div className='result-item-content'>
        <div className='result-item-main'>
          <div className='result-title-row'>
            <Text strong className='result-title'>
              {dataPoint?.label}
            </Text>
            {resultStatus === 'normal' ? (
              <Tag color='success' icon={<CheckCircleOutlined />} className='result-tag'>
                Normal
              </Tag>
            ) : resultStatus === 'abnormal' ? (
              <Tag color='error' icon={<ExclamationCircleOutlined />} className='result-tag'>
                Abnormal
              </Tag>
            ) : null}
          </div>

          <div className='result-value-row'>
            <Text className='result-value'>
              {result.value} {dataPoint?.suffix}
            </Text>
          </div>

          <div className='result-date'>
            <CalendarOutlined />
            <Text type='secondary'>{formatDate(result.dateCreated)}</Text>
          </div>
        </div>

        <div className='result-action'>
          <Button type='link' icon={<RightOutlined />} className='view-detail-btn' aria-label='View result details' />
        </div>
      </div>
    </div>
  )
}

export default ResultListItem
